import script from "./Material.vue?vue&type=script&setup=true&lang=ts"
export * from "./Material.vue?vue&type=script&setup=true&lang=ts"

import "./Material.vue?vue&type=style&index=0&id=1151025e&lang=scss&scoped=true"

import exportComponent from "E:\\云工厂标准版\\dmMes\\h5_standard\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1151025e"]])

export default __exports__